<template>
  <div v-if="isImpersonating" class="impersonation-banner">
    <v-icon color="white" class="mr-2">support_agent</v-icon>
    <div class="impersonation-banner__content">
      <span class="impersonation-banner__text">
        <strong>Impersonation active — ne rien modifier</strong>
        — vous consultez les données de
        <strong>{{ targetLabel }}</strong>
        <span v-if="contextAdminId" class="impersonation-banner__admin">
          (votre ID admin : <strong>#{{ contextAdminId }}</strong>)
        </span>
      </span>
      <v-btn
        small
        outlined
        color="white"
        :loading="stopLoading"
        @click="stopImpersonate"
      >
        <v-icon left small>logout</v-icon>
        Arrêter l'impersonation
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ImpersonationBanner',
  data() {
    return {
      stopLoading: false,
    }
  },
  computed: {
    ...mapGetters(['isImpersonating', 'contextClientId', 'contextAdminId']),
    client() {
      return this.$store.state.authentication.client
    },
    targetLabel() {
      const enseigne = this.client?.enseigne
      const name = this.client?.nom || this.client?.name
      const id = this.contextClientId
      const label = enseigne && name ? `${enseigne} — ${name}` : (name || enseigne)
      if (label && id) return `${label} (#${id})`
      if (label) return label
      return `#${id}`
    },
  },
  methods: {
    stopImpersonate() {
      this.stopLoading = true
      this.$store.dispatch('stopImpersonate')
        .then(() => {
          window.location.reload()
        })
        .catch(() => {
          this.stopLoading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.impersonation-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  background-color: #ff9800;
  color: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.impersonation-banner__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.impersonation-banner__text {
  flex: 1;
}

@media (max-width: 768px) {
  .impersonation-banner {
    left: 0;
  }
}
</style>
